// extracted by mini-css-extract-plugin
export default {"materialsCardFooter":"style-module--materialsCardFooter--8acc0","downloadText":"style-module--downloadText--c3b3a","fileSize":"style-module--fileSize--02fa6"};